// extracted by mini-css-extract-plugin
module.exports = {"smHeader":"BookSmarts_smHeader__2zWie","pageContainer":"BookSmarts_pageContainer__JP-CE"};